import { ROUTER_PATHS } from "@/shared";
import SaveRecepcionTransferenciaInventario from "../../shared/save_recepcion_transferencia_inventario/SaveRecepcionTransferenciaInventario";
import { LoaderComponent } from "@/shared/components/ui";
import { Navigate, useParams } from "react-router-dom";
import { useFetchGetTransitoInventarioById } from "@/shared/actions/erp/transito_inventaro.actions";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useEffect } from "react";

export default function EditRevisionTransferenciaInventarioPage() {

  const setModoValidacion = useCargarSeriesProductos(s => s.setModoValidacion)

  const { id } = useParams();

  const {
    data: dataTransferenciaInventario,
    isLoading: isLoadingTransferenciaInventario
  } = useFetchGetTransitoInventarioById(id!);


  useEffect(() => {
    setModoValidacion('traslado')
    return () => {

    }
  }, [])

  if (isLoadingTransferenciaInventario)
    return <LoaderComponent />

  if (!dataTransferenciaInventario)
    return <Navigate to={`${ROUTER_PATHS.inventario.recepcionTransferenciaInventarioNav}`} />

  return (
    <SaveRecepcionTransferenciaInventario
      title="↪️Recepción Transferencia de Inventario"
      dataTransferenciaInventario={dataTransferenciaInventario!}
    />
  )

}